"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const core_1 = require("@material-ui/core");
require("./actionBox.scss");
const profile_1 = require("../../../shared/components/profile");
const lawFirmProfileSlice_1 = require("../../../redux/slices/lawFirmProfileSlice");
const ActionBox = (props) => {
    const [deleteAccountModal, toggleDeleteModal] = react_1.useState(false);
    return (react_1.default.createElement(core_1.Box, { id: 'action-box' },
        react_1.default.createElement("div", { className: "w-100 btns-wrapper" },
            props.mainBtn,
            props.secondaryBtn),
        deleteAccountModal && react_1.default.createElement(profile_1.DeleteAccount, { open: deleteAccountModal, cancelable: {
                buttonTitle: 'Never Mind',
                action: () => toggleDeleteModal(!deleteAccountModal)
            }, submit: {
                buttonTitle: 'Delete',
                action: props.deleteAccount
            } })));
};
const mapDispatchToProps = (dispatch) => {
    return {
        deleteAccount: () => dispatch(lawFirmProfileSlice_1.deleteAccount())
    };
};
exports.default = react_redux_1.connect(null, mapDispatchToProps)(ActionBox);
